/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FormRiskEntry } from '../../models/form-risk-entry';
import { FormRiskEntryUpdateDtoList } from '../../models/form-risk-entry-update-dto-list';

export interface Claim$Params {
  formId: string;
  body: FormRiskEntryUpdateDtoList;
}

export function claim(
  http: HttpClient,
  rootUrl: string,
  params: Claim$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<Array<FormRiskEntry>>> {
  const rb = new RequestBuilder(rootUrl, claim.PATH, 'put');
  if (params) {
    rb.path('formId', params.formId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FormRiskEntry>>;
    })
  );
}

claim.PATH = '/forms/{formId}/risk-entry/claim';
